export function canvasWidth(spec) {
  return Number((spec.canvas || {}).width) || 1200;
}

export function flowLayouts(spec, measured = {}) {
  const placements = [...(spec.placements || [])].sort((a, b) => a.layout.y - b.layout.y);
  const out = {};
  placements.forEach((p) => {
    const { x, y, w, h } = p.layout;
    let shift = 0;
    placements.forEach((q) => {
      const done = out[q.id];
      if (!done || q.id === p.id) return;
      const above = q.layout.y + q.layout.h <= y;
      const overlaps = q.layout.x < x + w && x < q.layout.x + q.layout.w;
      if (above && overlaps) shift = Math.max(shift, done.y + done.h - (q.layout.y + q.layout.h));
    });
    const grown = p.layout.grow ? Math.max(h, Math.ceil(measured[p.id] || 0)) : h;
    out[p.id] = { ...p.layout, y: y + shift, h: grown };
  });
  return out;
}

export function canvasHeight(spec, layouts = null) {
  const bottoms = (spec.placements || []).map((p) => {
    const l = (layouts && layouts[p.id]) || p.layout;
    return l.y + l.h;
  });
  return Math.max(240, ...bottoms) + 24;
}

export function filterDefaults(spec) {
  const values = {};
  (spec.filters || []).forEach((f) => { values[f.name] = f.default ?? ''; });
  return values;
}

export function placeStyle(p, layout = null) {
  const l = layout || p.layout;
  return {
    left: l.x + 'px', top: l.y + 'px',
    width: l.w + 'px', height: l.h + 'px',
    zIndex: l.z || 1,
  };
}

export function stageStyle(spec) {
  const canvas = spec.canvas || {};
  return {
    background: canvas.background || 'transparent',
    padding: (Number(canvas.padding) || 0) + 'px',
  };
}

export function pageScope(spec, placement, host, filters, local) {
  const declared = Object.keys(spec.implicit || {});
  const pageFilters = (spec.filters || []).map((f) => f.name);
  const ownFilters = (placement.filters || []).map((f) => f.name);
  const filled = (v) => v !== null && v !== undefined && v !== '';
  const scope = {};
  Object.entries(spec.implicit || {}).forEach(([k, v]) => { if (v !== null) scope[k] = v; });
  Object.entries(host || {}).forEach(([k, v]) => { if (declared.includes(k) && filled(v)) scope[k] = v; });
  Object.entries(filters || {}).forEach(([k, v]) => { if (pageFilters.includes(k) && filled(v)) scope[k] = v; });
  Object.entries(placement.implicit || {}).forEach(([k, v]) => { if (v !== null) scope[k] = v; });
  Object.entries(local || {}).forEach(([k, v]) => { if (ownFilters.includes(k) && filled(v)) scope[k] = v; });
  return scope;
}

export function localDefaults(placement) {
  const values = {};
  (placement.filters || []).forEach((f) => { values[f.name] = f.default ?? ''; });
  return values;
}
